<template>
    <div>
        <div
            v-if="inProgress || reportData === null"
            class="d-flex align-items-center justify-content-center p-5">
            <b-spinner variant="yokumiru-admin"></b-spinner>
        </div>
        <div v-else>
            <div class="btnWrapper d-flex justify-content-end">
                <b-button
                    variant="yokumiru-orange"
                    @click="downloadPDF">
                    PDFダウンロード
                </b-button>
            </div>
            <div
                id="reportContainer"
                class="reportWrapper align-items-start justify-content-center">
                <div class="card cardReport">
                    <div class="card-header">レポート情報</div>
                    <div class="card-body pt-2">
                        <div class="reportHeaderBox">
                            <div class="vc-section reportHeaderBoxInner">
                                <div class="vc-detail">
                                    <div class="vc-detail__title">法人名</div>
                                    <div class="vc-detail__value">
                                        <span v-if="group.name === null || group.name === ''" class="text-muted">-</span>
                                        <span v-else>{{ group.name }}</span><!--
                                             --><span v-if="group.name_kana !== null" class="small text-muted">（{{ group.name_kana }}）</span>
                                    </div>
                                </div>
                                <div class="vc-detail">
                                    <div class="vc-detail__title">対象期間</div>
                                    <div class="vc-detail__value">{{ `${helper.dateForHuman(healthSurveyReport.term_start, 'Asia/Tokyo')}〜${helper.dateForHuman(healthSurveyReport.term_end, 'Asia/Tokyo')}` }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="reportHeaderBox">
                            <div class="vc-section reportHeaderBoxInner">
                                <div class="vc-detail">
                                    <div class="vc-detail__title">当月の利用者数</div>
                                    <div class="vc-detail__value">
                                        <span>{{ reportData.member_count }}人</span>
                                    </div>
                                </div>
                                <div class="vc-detail">
                                    <div class="vc-detail__title">当月の相談総数</div>
                                    <div class="vc-detail__value">
                                        <span>{{ reportData.consultations_count }}件</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="reportSection">
                            <div class="reportSectionHeader">回答率分布</div>
                            <div class="reportSectionBody reportSectionBodyCollapse">
                                <div class="answerRateWrapper">
                                    <div class="answerRateHeader">
                                        <div>0〜24%</div>
                                        <div>25%〜49%</div>
                                        <div>50%〜74%</div>
                                        <div>75%〜100%</div>
                                    </div>
                                    <div class="answerRateBody">
                                        <div><span>{{ answerRates[0] }}</span><span>人</span></div>
                                        <div><span>{{ answerRates[1] }}</span><span>人</span></div>
                                        <div><span>{{ answerRates[2] }}</span><span>人</span></div>
                                        <div><span>{{ answerRates[3] }}</span><span>人</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="reportSection">
                            <div class="reportSectionHeader">回答結果</div>
                            <div class="reportSectionBody">
                                <div
                                    v-for="template in healthSurveyTemplates"
                                    class="templateSection">
                                    <div class="templateSectionHeader">{{ template.name }}</div>
                                    <div class="templateSectionBody">
                                        <div class="templateGraphWrapper">
                                            <admin-health-survey-report-chart
                                                :report-data="reportData"
                                                :health-survey-template="template">
                                            </admin-health-survey-report-chart>
                                        </div>
                                        <table class="tableWrapper">
                                            <tr>
                                                <th class="font-weight-bold">有効回答率</th>
                                                <td class="tableRate">
                                                    <span>{{ completedRate(template) }}</span><!--
                                                 --><span>%</span>
                                                    <span>&nbsp;実施回数{{ completedDenominator(template) }}回</span>
                                                    <span v-if="template.name.includes('デイリー')" class="text-muted">&nbsp;(毎日平均{{ completedUsersRateCount(template) }}人が回答完了)</span>
                                                    <span v-else  class="text-muted">&nbsp;({{ completedUsersCount(template) }}人が回答完了)</span>
                                                </td>
                                            </tr>
                                        </table>
                                        <table class="tableWrapper">
                                            <tr>
                                                <th class="font-weight-bold">相談勧奨対象者数</th>
                                                <td class="tableRate">
                                                    <span>{{ severeUsersCount(template) }}</span><!--
                                                 --><span>人</span>
                                                </td>
                                            </tr>
                                        </table>
                                        <div
                                            v-if="isShowInfo(template)"
                                            class="templateInfo">
                                            <template v-if="template.name.includes('デイリー')">
                                                <span class="font-weight-bold">0～4点は</span><span class="font-weight-bold red">優良者</span>、<span class="font-weight-bold">5～8点は</span><span class="font-weight-bold red">良者</span>、<span class="font-weight-bold">9点以上は</span><span class="font-weight-bold red">経過観察</span>と評価。経過観察と評価された方には、相談医師への相談を促す案内メールを送信しております。※デイリーヨクミルの詳細は管理者向け蘊奥ガイドをご確認ください。
                                            </template>
                                            <template v-else-if="template.name.includes('PHQ-9')">
                                                <span class="font-weight-bold">PHQ-9&nbsp;(Patient&nbsp;Health&nbsp;Questionnaire-9）</span>はうつ病の有無や重症度を自己評価することができる指標。 選択肢 （0．全くない，1．週に数日，2．週の半分以上，3.ほとんど毎日） の中から一つ選んで回答します。合計点が<span class="font-weight-bold">0～4点は</span><span class="font-weight-bold red">軽微</span>、<span class="font-weight-bold">5～9点は</span><span class="font-weight-bold red">軽度</span>、<span class="font-weight-bold">10～14点は</span><span class="font-weight-bold red">中等度</span>、<span class="font-weight-bold">15～19点は</span><span class="font-weight-bold red">中等度～重度</span>、<span class="font-weight-bold">20～27点は</span><span class="font-weight-bold red">重度</span>として、抑うつ症状の評価ができます。10点以上の中等度、中等度～重度、重度と評価された方には、メンタルヘルス科の医師に相談を促す案内メールをお送りさせて頂いております。
                                            </template>
                                            <template v-else-if="template.name.includes('GAD-7')">
                                                <span class="font-weight-bold">GAD-7&nbsp;(Generalized&nbsp;Anxiety&nbsp;Disorder-7)</span>は全般性不安障害（GAD）の重症度を評価するための質問票となります。選択肢 （0．全くない，1．週に数日，2．週の半分以上，3.ほとんど毎日） の中から一つ選んで回答します。21点満点で合計点が<span class="font-weight-bold">0～4点は</span><span class="font-weight-bold red">軽微</span>、<span class="font-weight-bold">5～9点は</span><span class="font-weight-bold red">軽度</span>、<span class="font-weight-bold">10～14点は</span><span class="font-weight-bold red">中等度</span>、<span class="font-weight-bold">15～21点は</span><span class="font-weight-bold red">重度</span>のGADと評価ができます。10点以上の中等度、重度と評価された方には、メンタルヘルス科の医師に相談を促す案内メールをお送りさせて頂いております。
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../constants'
import YokumiruHelper from '../../YokumiruHelper'

export default {
    props: {
        group: {
            type: Object,
            required: true,
        },
        healthSurveyReport: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            reportData: null,
        }
    },

    computed: {
        // /**
        //  * 質問デッキ表記
        //  * @return {string}
        //  */
        // templateNames: function () {
        //     return this.healthSurveyReport.health_survey_templates.map((template) => template.name).join(', ')
        // },

        /**
         * 回答率を返す
         * @return {array}
         */
        answerRates: function () {
            let rate1 = 0 // 0〜24%
            let rate2 = 0 // 25〜49%
            let rate3 = 0 // 50〜74%
            let rate4 = 0 // 75〜100%

            if (this.reportData !== null) {
                this.reportData.reports.forEach((report) => {
                    const rate = Number(report.answer_rate)
                    if (rate < 25) rate1++
                    else if (rate < 50) rate2++
                    else if (rate < 75) rate3++
                    else rate4++
                })
            }
            return [rate1, rate2, rate3, rate4]
        },

        /**
         * 質問デッキのリスト
         * @return {array}
         */
        healthSurveyTemplates: function () {
            if (!this.reportData) return []
            return this.reportData.health_survey_templates
        },
    },

    created: async function () {
        await this.fetchHealthSurveyReport()
    },

    methods: {
        /**
         * レポートのPDFダウンロード
         */
        downloadPDF: function () {
            const date = this.helper.userTime(this.healthSurveyReport.term_start, 'Asia/Tokyo')

            // npm の html2pdf を使用すると build の際にCSSが空になる問題があるため、cdn を利用している
            // @see views/admin/health_survey_reports/show.blade.php
            html2pdf(document.getElementById('reportContainer'), {
                margin: 10,
                filename: `${date.format('YYYY年M月')}_ヘルスアンサーレポート.pdf`,
            })
        },

        /**
         * レポートデータ取得
         */
        fetchHealthSurveyReport: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.health_survey_reports.endpoint.base

            await axios.get(`${endpoint}/${this.healthSurveyReport.id}`)
                .then(({data}) => {
                    this.reportData = data.data
                })

            this.inProgress = false
        },

        /**
         * 有効回答率を返す
         * @param {object} template
         * @return {number}
         */
        completedRate: function (template) {
            // 分母（有効回答となり得る最大件数）
            const denominator = this.completedDenominator(template)

            // 分子（実際の有効回答数）
            const numerator = this.completedNumerator(template)

            if (denominator < 1) return 0
            return Math.floor(numerator / denominator * 100)
        },

        /**
         * 有効回答率の分母（有効回答となり得る最大件数）
         * @param {object} template
         * @return {number}
         */
        completedDenominator: function (template) {
            let denominator = 1
            for (let key in this.reportData.max_complete_counts) {
                if (key === template.id.toString()) {
                    denominator = this.reportData.max_complete_counts[key]
                }
            }
            return denominator
        },

        /**
         * 有効回答率の分子（実際の有効回答数）
         * @param {object} template
         * @return {number}
         */
        completedNumerator: function (template) {
            let numerator = 0
            this.reportData.reports.forEach((report) => {
                for (let key in report.completed_counts) {
                    if (key === template.id.toString()) {
                        numerator += report.completed_counts[key]
                    }
                }
            })
            return numerator
        },

        /**
         * 有効回答したことがある会員の数
         * @param {object} template
         * @return {number}
         */
        completedUsersCount: function (template) {
            const userIds = []
            this.reportData.reports.forEach((report) => {
                for (let key in report.completed_counts) {
                    if (
                        key === template.id.toString()
                        && report.completed_counts[key] > 0
                        && !userIds.includes(report.user_id)
                    ) {
                        userIds.push(report.user_id)
                    }
                }
            })
            return userIds.length
        },

        /**
         * 有効回答したことがある会員の割合人数
         * @param {object} template
         * @return {number}
         */
        completedUsersRateCount: function (template) {
            const rate = this.completedRate(template) / 100
            return Math.floor(rate * this.reportData.member_count * 100) / 100 // 少数第2位まで残す
        },

        /**
         * 相談勧奨対象者数
         * @param {object} template
         * @return {number}
         */
        severeUsersCount: function (template) {
            let count = 0
            this.reportData.reports.forEach((report) => {
                for (let key in report.severe_counts) {
                    if (key === template.id.toString() && report.severe_counts[key] > 0) {
                        count++
                    }
                }
            })
            return count
        },

        /**
         * 質問デッキの詳細文言を表示するかどうか
         * @param {object} template
         * @return {boolean}
         */
        isShowInfo: function (template) {
            return template.name.includes('デイリー')
                || template.name.includes('PHQ-9')
                || template.name.includes('GAD-7')
        },
    },
}
</script>

<style scoped lang="scss">
.vc-section {
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }
}

.vc-head-detail {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 0;
    padding: 10px 0 0;
}

.vc-detail {
    margin: 8px 0;

    .vc-detail__title {
        color: #6c757d;
    }

    .vc-detail__value {
        padding: 4px 0 3px;
        border-bottom: 1px solid #dfdfdf;
    }
}

.btnWrapper {
    width: 720px;
    margin: 0 auto 10px;

    @media screen and (max-width:991px) {
        width: 100%;
    }
}

.reportWrapper {
    width: 720px;
    margin: 0 auto;
    color: #1E1E1E;

    @media screen and (max-width:991px) {
        width: 100%;
    }
}

.reportHeaderBox {
    margin: 10px 0 30px;
    padding: 15px 20px;
    border: 1px solid #dfdfdf;
    border-radius: 6px;

    .reportHeaderBoxInner {
        display: flex;

        @media screen and (max-width:767px) {
            display: block;
        }

        .vc-detail {
            flex-grow: 1;

            &:nth-child(1) {
                margin-right: 20px;

                @media screen and (max-width:767px) {
                    margin-right: 0;
                }
            }
        }
    }
}

.reportSection {
    margin-bottom: 30px;
    border: 1px solid #ddd;
    border-radius: 6px;

    .reportSectionHeader {
        padding: 10px 15px;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
        background: #98ACC0;
        border-radius: 6px 6px 0 0;
    }

    .reportSectionBody {
        padding: 20px;

        &.reportSectionBodyCollapse {
            padding: 0;
        }
    }
}

.answerRateWrapper {
    .answerRateHeader,
    .answerRateBody {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .answerRateHeader {
        font-size: 13px;
        font-weight: bold;
        text-align: center;
        border-bottom: 1px solid #ddd;

        > div {
            width: 25%;
            padding: 10px;

            &:nth-child(1) {
                background: #FFD6D6;
                border-right: 1px solid #FFD6D6;
            }
            &:nth-child(2) {
                background: #FFE4C6;
                border-right: 1px solid #FFE4C6;
            }
            &:nth-child(3) {
                background: #B6EBAD;
                border-right: 1px solid #B6EBAD;
            }
            &:nth-child(4) {
                background: #A5E7F4;
                border-right: none;
            }
        }
    }

    .answerRateBody {
        text-align: center;

        > div {
            width: 25%;
            padding: 10px;
            border-right: 1px solid #ddd;

            &:nth-child(4) {
                border-right: none;
            }

            span {
                &:nth-child(1) {
                    font-size: 18px;
                    font-weight: bold;
                }
            }
        }
    }
}

.templateSection {
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 0 0 6px 6px;

    .templateSectionHeader {
        padding: 5px 10px;
        font-size: 14px;
        font-weight: bold;
        background: #D9EDF7;
    }

    .templateSectionBody {
        padding: 15px;

        .templateInfo {
            padding: 20px;
            font-size: 12px;
            background: #F8F8F8;
            border-radius: 6px;
        }

        .red {
            color: #FF0000;
        }
    }
}

.tableWrapper {
    width: 100%;
    margin: 20px 0;
    border: 1px solid #ddd;

    th, td {
        padding: 20px;
        font-size: 14px;
        border-right: 1px solid #ddd;
    }

    th {
        width: 220px;
        background: #F8F8F8;

        @media screen and (max-width: 767px) {
            width: 160px;
        }
    }

    .tableRate {
        span {
            &:nth-child(1) {
                font-size: 18px;
                font-weight: bold;
            }
            &:nth-child(2) {
                font-size: 16px;
                font-weight: bold;
            }
        }
    }
}
</style>
